module.exports = __webpack_public_path__ + "static/DSC00257-451197615c158d54d508c58b40334288.jpg";